import i18next from 'i18next';
import { defaultNS, ns, resources } from './i18n/resources';
import { getFallbackLanguage, getLanguage } from 'src/_shared/utils/getLanguage';

i18next.init({
  ns,
  compatibilityJSON: 'v3',
  defaultNS,
  fallbackLng: getFallbackLanguage(),
  resources,
  lng: getLanguage(),
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
